import tokenizeGraphqlName from './tokenizeGraphqlName.js';

const normalizeGraphqlName = (name) => {
  return tokenizeGraphqlName(name).join('');
};

export default normalizeGraphqlName;
